export function shortenNumber(numero: number) {
  if (numero < 1000) {
    return numero.toString();
  }

  const sufixos = ['', 'K', 'M', 'B', 'T']; // Pode adicionar mais sufixos se necessário
  let indice = 0;
  let numAbreviado = numero;

  while (numAbreviado >= 1000 && indice < sufixos.length - 1) {
    numAbreviado /= 1000;
    indice++;
  }

  // Formata para até 2 casas decimais e remove zeros desnecessários
  const numFormatado = numAbreviado.toFixed(2).replace(/\.?0+$/, '');

  return numFormatado + sufixos[indice];
}
